module.exports = __webpack_public_path__ + "static/exclude-machine-946c49e28fe65c61e91e5eaa4d5596ef.mp4";